webpackJsonp([158504395437187],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageGallery = __webpack_require__(41);
	
	var _ImageGallery2 = _interopRequireDefault(_ImageGallery);
	
	var _images = __webpack_require__(24);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imagesModalIllustrations = _images2.default["illustrations"][0];
	var imagesThumbIllustrations = _images2.default["illustrations"][1];
	
	var imagesModalTits = _images2.default["tits"][0];
	var imagesThumbTits = _images2.default["tits"][1];
	
	var imagesModalObjects = _images2.default["objects"][0];
	var imagesThumbObjects = _images2.default["objects"][1];
	
	var imagesModalMonsters = _images2.default["monsters"][0];
	var imagesThumbMonsters = _images2.default["monsters"][1];
	
	var imagesModal = _images2.default["others"][0].filter(function (pic, index) {
	    return index === 0 || index === 7;
	});
	var imagesThumb = _images2.default["others"][1].filter(function (pic, index) {
	    return index === 0 || index === 7;
	});
	
	var imagesBlob = _images2.default["blob"][0];
	var imagesBlobThumbs = _images2.default["blob"][1];
	
	var Skateboards = function Skateboards() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ImageGallery2.default, { imagesModal: imagesModalIllustrations.filter(function (pic, index) {
	                return index <= 7;
	            }), imagesThumb: imagesThumbIllustrations.filter(function (pic, index) {
	                return index <= 7;
	            }), tabName: 'ILLUSTRATION_CIRCLE' }),
	        _react2.default.createElement(_ImageGallery2.default, { imagesModal: imagesModalIllustrations.filter(function (pic, index) {
	                return index >= 8;
	            }), imagesThumb: imagesThumbIllustrations.filter(function (pic, index) {
	                return index >= 8;
	            }), tabName: 'ILLUSTRATION_SQUARE' })
	    );
	};
	
	exports.default = Skateboards;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-illustration-js-3b5964665646d5605162.js